// extracted by mini-css-extract-plugin
export var grid = "_j-0";
export var span1 = "_j-2";
export var span10 = "_j-b";
export var span10L = "_j-z";
export var span10M = "_j-n";
export var span10Xl = "_j-1b";
export var span11 = "_j-c";
export var span11L = "_j-10";
export var span11M = "_j-o";
export var span11Xl = "_j-1c";
export var span12 = "_j-d";
export var span12L = "_j-11";
export var span12M = "_j-p";
export var span12Xl = "_j-1d";
export var span1L = "_j-q";
export var span1M = "_j-e";
export var span1Xl = "_j-12";
export var span2 = "_j-3";
export var span2L = "_j-r";
export var span2M = "_j-f";
export var span2Xl = "_j-13";
export var span3 = "_j-4";
export var span3L = "_j-s";
export var span3M = "_j-g";
export var span3Xl = "_j-14";
export var span4 = "_j-5";
export var span4L = "_j-t";
export var span4M = "_j-h";
export var span4Xl = "_j-15";
export var span5 = "_j-6";
export var span5L = "_j-u";
export var span5M = "_j-i";
export var span5Xl = "_j-16";
export var span6 = "_j-7";
export var span6L = "_j-v";
export var span6M = "_j-j";
export var span6Xl = "_j-17";
export var span7 = "_j-8";
export var span7L = "_j-w";
export var span7M = "_j-k";
export var span7Xl = "_j-18";
export var span8 = "_j-9";
export var span8L = "_j-x";
export var span8M = "_j-l";
export var span8Xl = "_j-19";
export var span9 = "_j-a";
export var span9L = "_j-y";
export var span9M = "_j-m";
export var span9Xl = "_j-1a";
export var stretch = "_j-1";